import { PropsWithChildren } from 'react'
import { FloraProvider, FloraProviderProps } from '@grupoboticario/flora-react'
import { BrandTheme } from 'src/@enums'
import { getConfig } from 'src/helpers'

const { brandEnv } = getConfig()
export const brandTheme = BrandTheme[brandEnv]

export type BrandThemeProviderProps = Omit<FloraProviderProps, 'theme'>

/**
 * Provider do tema do Flora, já levando em conta a marca "boticário", "oui", etc.
 */
export const BrandThemeProvider = ({
  children,
  ...props
}: PropsWithChildren<BrandThemeProviderProps>) => (
  <FloraProvider
    theme={BrandTheme[brandEnv]}
    resetCSS
    {...props}
  >
    {children}
  </FloraProvider>
)
